<template>
  <div class="h-screen w-full px-10 flex justify-center items-center">
    <div>
      <div v-if="isOverExaminationReceptionEnd">
        <p class="text-CLIENT_BL leading-5 md:text-xl text-center">
          申し訳ありません。
        </p>
        <p class="mt-8 text-CLIENT_BL leading-5 md:text-xl text-center">
          試験実施期間が終了しました。
        </p>
      </div>
      <div v-else>
        <p class="text-CLIENT_BL leading-5 text-xl md:text-3xl text-center">
          試験が終了しました。
        </p>
      </div>
      <div class="mx-auto text-CLIENT_BL text-thin text-center">
        <p class="mt-4 md:text-2xl">
          模試名:<span> {{ props.examinationTitle }}</span>
        </p>
        <p class="md:text-2xl">
          模試種別:<span> {{ currentExaminationType }}</span>
        </p>
      </div>
      <div v-if="isFinishAll">
        <p class="mt-4 leading-5 text-xl md:text-2xl text-center text-red-500">
          すべての模試種別について<br class="hidden sp:inline" />実施済みとなりました。
        </p>
        <p
          v-if="examination.is_subscription_item"
          class="mt-10 text-CLIENT_BL md:text-xl text-center">
          国家試験対策模試の受験、大変お疲れ様でした。<br class="inline sp:hidden" />
          成績を含めた解答解説は、成績タブより閲覧ください。<br class="inline sp:hidden" />
          ぜひ復習と今後の学習にお役立てくださいませ。<br class="inline sp:hidden" />
          これからも皆様の受験勉強をサポートさせて頂けますと幸いです。<br class="inline sp:hidden" />
          ブラウザを閉じ受験を終了してください。
        </p>
        <p
          v-else
          class="mt-10 text-CLIENT_BL md:text-xl text-center">
          国家試験対策模試の受験、大変お疲れ様でした。<br class="inline sp:hidden" />解答解説は、成績タブより閲覧いただけます。<br
            class="inline sp:hidden" />ぜひ復習と今後の学習にお役立てくださいませ。<br class="inline sp:hidden" />
          また、点数・順位については成績集計開始日後に成績タブより閲覧可能となります<br class="inline sp:hidden" />
          これからも皆様の受験勉強をサポートさせて頂けますと幸いです。<br class="inline sp:hidden" />
          ブラウザを閉じ受験を終了してください。
        </p>
      </div>
      <div v-else>
        <p class="mt-10 text-CLIENT_BL md:text-xl text-center">
          他の種別の模試実施にお進みください。
        </p>
      </div>
      <button
        class="block mx-auto mt-6 px-8 py-2 rounded bg-blue-600 text-blue-50 max-w-max shadow-sm hover:shadow-lg"
        @click="backToClientTop">
        TOPへ戻る
      </button>
    </div>
  </div>
</template>
<script setup>
import { Inertia } from '@inertiajs/inertia'
import { usePage } from '@inertiajs/inertia-vue3'
import { defineProps, computed } from 'vue'

const props = defineProps({
  examination: {
    type: Object,
    default: () => { },
  },
  examinationId: {
    type: Number,
    default: 0,
  },
  examinationTitle: {
    type: String,
    default: '',
  },
  examinationType: {
    type: Number,
    default: 0,
  },
  isOverExaminationReceptionEnd: {
    type: Boolean,
    default: false,
  },
  isFinishAll: {
    type: Boolean,
    default: false,
  },
})

const currentExaminationType = computed(() => usePage().props.value.examinationTypes[props.examinationType])

const backToClientTop = () => {
  Inertia.get(route('client-examinations'))
  localStorage.clear()
}

window.history.pushState(null, null, null)
window.addEventListener('popstate', () => {
  window.history.pushState(null, null, null)
})
</script>
